import classNames from "classnames";
import * as React from "react";

export interface FooterProps {
  children: any;
  contentPosition?: "left" | "right" | "stretch";
}

const Footer = (props: FooterProps) => (
  <div
    className={classNames("modal-footer", {
      left: props.contentPosition === "left",
      stretch: props.contentPosition === "stretch"
    })}
  >
    {props.children}
  </div>
);
export default Footer;
